<template>
    <span class="omnistock omni-button-collection" :class="computedClassNames">
        <slot />
    </span>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "OmniButtonCollection",
    props: {
        direction: {
            type: String,
            default: "horizontal",
        },
        alignment: {
            type: String,
            default: "start",
        }
    },
    computed: {
        computedClassNames() {
            return [
                `direction-${this.direction} algn-${this.alignment}`,
            ];
        },
    },
});
</script>

<style lang="scss">
.omnistock {
    &.omni-button-collection {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        gap: .75rem;


        &.drection {
            &-horizontal {
                flex-direction: row;
            }
            &-vertical {
                flex-direction: column;
            }
            &-horizontal-reverse {
                flex-direction: row-reverse;
            }
            &-vertical-reverse {
                flex-direction: column-reverse;
            }
        }

        &.algn { // not a typo, align-* are existing class names.
            &-start {
                justify-content: flex-start;
            }
            &-center {
                justify-content: center;
            }
            &-end {
                justify-content: flex-end;
            }
        }

    }
}
</style>
